module.exports = __webpack_public_path__ + "static/media/524GriffinStNW_2018-06-05_11.75e8ca76.jpg";